import { AxiosResponse } from 'axios';
import axiosServices from 'utils/axios';

const SYNCHRONIZE_USER_GROUPS = 'synchronizeUsersInGroup';

export const SynchronizeUserGroup = async (userGroupId: number): Promise<AxiosResponse | null | undefined> => {
    try {
        return await axiosServices.post(`${SYNCHRONIZE_USER_GROUPS}/${userGroupId}`);
    } catch (err) {
        const errorResponse = err as AxiosResponse;
        if (errorResponse) return errorResponse;
        return null;
    }
};
